import React from "react";
import { useSelector } from "react-redux";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import BroadcastSubscriber from "modules/broadcast/BroadcastSubscriber";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import { selectIsBroadcasting } from "modules/broadcast/redux/selectors";
import { selectNetworkIsConnected } from "modules/network/redux/selectors";

interface IEventViewDataLayerProps {
  children: React.ReactNode;
}

const EventViewDataLayer = ({ children }: IEventViewDataLayerProps) => {
  const { t } = useI18n();
  const [isLoading, setIsLoading] = React.useState(true);
  const isBroadcasting = useSelector(selectIsBroadcasting);
  const currentTheaterId = useSelector(selectCurrentTheaterId);
  const isConnected = useSelector(selectNetworkIsConnected);
  const isBroadcastDataReady = isBroadcasting !== null;

  React.useEffect(() => {
    if (!isBroadcastDataReady) return;

    setIsLoading(false);
  }, [isBroadcastDataReady]);

  return (
    <>
      {currentTheaterId && isConnected && <BroadcastSubscriber />}
      {isLoading ? <PageLoader message={t("loading")} /> : children}
    </>
  );
};

export default EventViewDataLayer;
